import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        importModal: {
          upload: 'Upload file',
          import: 'Import',
          cancel: 'Cancel',
          importPreview: 'IMPORT PREVIEW',
          downldIncorrectRows: 'Incorrect rows count',
          tableHeader: {
            pn: 'PN',
            sn: 'SN',
            repairStatus: 'Repair status',
            tracking: 'Tracking',
            rootCause: 'Root cause',
            correctiveAction: 'Corrective action',
            status: 'Status',
            comment: 'Comment'
          },
          repairStatus: {
            s1: 'Not yet started',
            s2: 'In progress',
            s3: 'Finished',
            s4: 'Shipped back',
          },
        },
        headerLanguageDropdown: {
          tooltip: 'Switch Language',
          hun: 'Hungarian',
          us: 'English (US)',
          tw: 'Taiwan',
        },
        headerMenu: {
          theme: 'Theme',
          dark: 'Dark mode',
          light: 'Light mode',
          logout: 'Logout',
        },
        dataTable: {
          pn: 'PN',
          sn: 'SN',
          rmaNumber: 'RMA Nr.',
          shippedDate: 'Shipped date',
          vendorName: 'Vendor - RMA vendor name',
          shipToCompany: 'Vendor - Shipping company name',
          l1faDisposition: 'L1FA Disposition',
          detailedL2fa: 'Detailed L2FA',
          repairStatus: 'Repair status',
          trackingNumber: 'Tracking number',
          comments: 'Comments',
          l2faDisposition: 'L2FA Disposition',
          rootCause: 'L2FA Root cause',
          correctiveAction: 'L2FA Corrective action',
          noData: 'No data available',
          dataError: 'An error occurred while loading data',
          warnings: {
            rowValidation: 'row(s) have been validated',
            errorValidation: 'Failed to validate the file',
            detailedL2FA: 'For rows with Detailed L2FA, L2FA, Root cause and Corrective action are required',
            noRowToImport: 'No valid rows to import',
            successImport: 'row(s) were successfully imported',
            failedImport: 'Failed to import',
          },
        },
        mainPage: {
          import: 'Import data',
          export: 'Export CSV',
          searchPN: 'Search by PN',
          searchSN: 'Search by SN',
          searchRMA: 'Search by RMA',
          exportModal: {
            title: 'Export data',
            all: 'All data',
            filtered: 'Filtered data',
            currentPage: 'Current page',
            selected: 'Selected rows',
            export: 'Export',
            cancel: 'Cancel'
          }
        },
        userManagementPage: {
          pageTitle: 'User Management',
          refresBtn: 'Refresh',
          newUserModal: {
            title: 'Create New User',
            username: 'Username',
            email: 'Email Address',
            firstName: 'First Name',
            lastName: 'Last Name',
            tempPswd: 'Temporary Password',
            createUserBtn: 'Create User',
            createdUser: 'Created User:',
            vendor: 'Vendor',
            vendorPlaceholder: 'Choose a vendor...'
          },
          vendorModal: {
            title: 'Manage User Vendors',
            user: 'User',
            userPlaceholder: 'Select a user',
            vendor: 'Vendors',
            vendorPlaceholder: 'Select vendors',
            saveVendorBtn: 'Save Vendors',
          },
          adminModal: {
            title: 'Manage Admin Business Assignment',
            admin: 'Admin',
            adminPlaceholder: 'Select an admin',
            business: 'Business',
            businessPlaceholder: 'Select a business',
            saveBusinessBtn: 'Save Business',
          },
          newAdminModal: {
            title: 'Create New Admin',
            username: 'Username',
            email: 'Email',
            firstName: 'First Name',
            lastName: 'Last Name',
            tempPswd: 'Temporary Password',
            business: 'Business',
            businessPlaceholder: 'Select businesses',
            createAdminBtn: 'Create Admin',
            createdAdmin: 'Created Admin',
          },
          alertMessages: {
            failedLoadUsers: 'Failed to load users',
            failedLoadVendors: 'Failed to load vendors',
            failedLoadUsersVendors: 'Failed to load user vendors',
            successCreateUser: 'User created successfully',
            failedCreateUser: 'Failed to create user',
            successSaveVendor: 'Vendors saved successfully',
            failedSaveVendor: 'Failed to save vendors',
            usernameRequired: 'Username is required',
            emailRequired: 'Email address is required',
            invalidEmail: 'Invalid email address',
            firstnameRequired: 'First name is required',
            lastnameRequired: 'Last name is required',
            pwdRequired: 'Password is required',
            chooseUserRequired: 'Please select a user',
            successUpdateBusiness: 'Business updated successfully.',
            successRemoveBusiness: 'Business assignment removed successfully.',
            failedUpdateBusiness: 'Failed to update business assignment.',
            failedLoadAdmins: 'Failed to load admins.',
            failedLoadBusinesses: 'Failed to load businesses.',
            invalidAdminEmailDomain: 'Invalid email address domain',
            businessRequired: 'Business is required',
            vendorRequired: 'Vendor is required',
          },
          tabs: {
            createUser: 'Create New User',
            createAdmin: 'Create New Admin',
            vendorManagement: 'Vendor Management',
            adminManagement: 'Admin Management',
          }
        },
      },
    },
    hu: {
      translation: {
        importModal: {
          upload: 'Fájl feltöltése',
          import: 'Importálás',
          cancel: 'Mégse',
          importPreview: 'IMPORT ELŐNÉZET',
          downldIncorrectRows: 'Hibás sorok száma',
          tableHeader: {
            pn: 'PN',
            sn: 'SN',
            repairStatus: 'Repair státusz',
            tracking: 'Nyomonkövetési szám',
            rootCause: 'Hiba oka',
            correctiveAction: 'Javító intézkedések',
            status: 'Státusz',
            comment: 'Komment'
          },
          repairStatus: {
            s1: 'Kezdésre vár',
            s2: 'Folyamatban',
            s3: 'Befejezett',
            s4: 'Visszaküldve',
          },
        },
        headerLanguageDropdown: {
          tooltip: 'Nyelv kiválasztása',
          hun: 'Magyar',
          us: 'Angol (US)',
          tw: 'Tajvan',
        },
        headerMenu: {
          theme: 'Megjelenés',
          dark: 'Sötét mód',
          light: 'Világos mód',
          logout: 'Kijelentkezés',
        },
        dataTable: {
          pn: 'PN',
          sn: 'SN',
          rmaNumber: 'RMA szám',
          shippedDate: 'Kiszállítás dátuma',
          vendorName: 'Beszállító - RMA beszállító neve',
          shipToCompany: 'Beszállító - Kiszállító cég neve',
          l1faDisposition: 'L1FA diszpozíció',
          detailedL2fa: 'Részletes L2FA',
          repairStatus: 'Javítás státusza',
          trackingNumber: 'Nyomkövetési szám',
          comments: 'Megjegyzések',
          l2faDisposition: 'L2FA diszpozíció',
          rootCause: 'L2FA gyökérok',
          correctiveAction: 'L2FA javítási intézkedés',
          noData: 'Nincs megjeleníthető adat',
          dataError: 'Hiba történt az adatok betöltésekor',
          warnings: {
            rowValidation: 'sor validálva',
            errorValidation: 'Nem sikerült validálni a fájlt',
            detailedL2FA: 'A Detailed L2FA-s valid soroknál kötelező az L2FA, Root cause és Corrective action',
            noRowToImport: 'Nincs importálható valid sor',
            successImport: 'sor sikeresen importálva',
            failedImport: 'Nem sikerült importálni',
          },
        },
        mainPage: {
          import: 'Adatok importálása',
          export: 'CSV letöltése',
          searchPN: 'Keresés PN alapján',
          searchSN: 'Keresés SN alapján',
          searchRMA: 'Keresés RMA alapján',
          exportModal: {
            title: 'Adatok exportálása',
            all: 'Összes adat',
            filtered: 'Szűrt adatok',
            currentPage: 'Aktuális oldal',
            selected: 'Kijelölt sorok',
            export: 'Exportálás',
            cancel: 'Mégse'
          }
        },
        userManagementPage: {
          pageTitle: 'Felhasználókezelés',
          refresBtn: 'Frissítés',
          newUserModal: {
            title: 'Új felhasználó létrehozása',
            username: 'Felhasználónév',
            email: 'E-mail cím',
            firstName: 'Keresztnév',
            lastName: 'Vezetéknév',
            tempPswd: 'Ideiglenes jelszó',
            createUserBtn: 'Felhasználó létrehozása',
            createdUser: 'Létrehozott user:',
            vendor: 'Beszállító',
            vendorPlaceholder: 'Válasszon beszállítót...'
          },
          adminModal: {
            title: 'Admin business hozzárendelés kezelése',
            admin: 'Admin',
            adminPlaceholder: 'Válassz admint',
            business: 'Business',
            businessPlaceholder: 'Válassz business értéket',
            saveBusinessBtn: 'Business mentése',
          },
          newAdminModal: {
            title: 'Új admin létrehozása',
            username: 'Felhasználónév',
            email: 'Email',
            firstName: 'Keresztnév',
            lastName: 'Vezetéknév',
            tempPswd: 'Ideiglenes jelszó',
            business: 'Business',
            businessPlaceholder: 'Válassz business értékeket',
            createAdminBtn: 'Admin létrehozása',
            createdAdmin: 'Létrehozott admin',
          },
          vendorModal: {
            title: 'Felhasználói beszállítók kezelése',
            user: 'Felhasználó',
            userPlaceholder: 'Válassz felhasználót',
            vendor: 'Beszállítók',
            vendorPlaceholder: 'Válassz beszállítót',
            saveVendorBtn: 'Beszállítók mentése',
          },
          alertMessages: {
            failedLoadUsers: 'Felhasználók betöltése sikertelen',
            failedLoadVendors: 'Beszállítók betöltése sikertelen',
            failedLoadUsersVendors: 'Felhasználók beszállítóinak betöltése sikertelen',
            successCreateUser: 'Felhasználó sikeresen létrehozva',
            failedCreateUser: 'Felhasználó létrehozása sikertelen',
            successSaveVendor: 'Beszállítók sikeresen mentve',
            failedSaveVendor: 'Beszállítók mentése sikertelen',
            usernameRequired: 'Felhasználónév kötelező',
            emailRequired: 'E-mail cím kötelező',
            invalidEmail: 'Érvénytelen email cím',
            firstnameRequired: 'Keresztnév kötelező',
            lastnameRequired: 'Vezetéknév kötelező',
            pwdRequired: 'Jelszó kötelező',
            chooseUserRequired: 'Felhasználó választása kötelező',
            successUpdateBusiness: 'A business sikeresen frissítve.',
            successRemoveBusiness: 'A business hozzárendelése sikeresen eltávolítva.',
            failedUpdateBusiness: 'Nem sikerült frissíteni a business hozzárendelését.',
            failedLoadAdmins: 'Adminok betöltése sikertelen',
            failedLoadBusinesses: 'Business-ek betöltése sikertelen',
            invalidAdminEmailDomain: 'Email cím domain helytelen',
            businessRequired: 'Business kötelező',
            vendorRequired: 'Beszállító megadása kötelező',
          },
          tabs: {
            createUser: 'Új felhasználó létrehozása',
            createAdmin: 'Új admin létrehozása',
            vendorManagement: 'Beszállítókezelés',
            adminManagement: 'Admin kezelés',
          }
        },
      },
    },
    zhTW: {
      translation: {
        importModal: {
          upload: '上傳檔案',
          import: '匯入',
          cancel: '取消',
          importPreview: '匯入預覽',
          downldIncorrectRows: '錯誤資料列數',
          tableHeader: {
            pn: '料號',
            sn: '序號',
            repairStatus: '維修狀態',
            tracking: '追蹤號碼',
            rootCause: '根本原因',
            correctiveAction: '矯正措施',
            status: '狀態',
            comment: '評論'
          },
          repairStatus: {
            s1: '尚未開始',
            s2: '進行中',
            s3: '已完成',
            s4: '已寄回',
          },
        },

        headerLanguageDropdown: {
          tooltip: '切換語言',
          hun: '匈牙利語',
          us: '美式英文',
          tw: '繁體中文（台灣）',
        },

        headerMenu: {
          theme: '主題',
          dark: '深色模式',
          light: '淺色模式',
          logout: '登出',
        },

        dataTable: {
          pn: '料號',
          sn: '序號',
          rmaNumber: 'RMA 編號',
          shippedDate: '出貨日期',
          vendorName: '供應商名稱',
          shipToCompany: '收貨公司',
          l1faDisposition: 'L1FA 判定',
          detailedL2fa: '詳細 L2FA',
          repairStatus: '維修狀態',
          trackingNumber: '追蹤號碼',
          comments: '備註',
          l2faDisposition: 'L2FA 判定',
          rootCause: '根本原因',
          correctiveAction: '矯正措施',
          noData: '沒有資料',
          dataError: '載入資料時發生錯誤',
          warnings: {
            rowValidation: '資料列已完成驗證',
            errorValidation: '檔案驗證失敗',
            detailedL2FA: '對於包含 Detailed L2FA 的資料列，必須填寫 L2FA、根本原因及矯正措施',
            noRowToImport: '沒有可匯入的有效資料列',
            successImport: '資料列已成功匯入',
            failedImport: '匯入失敗',
          },
        },

        mainPage: {
          import: '匯入資料',
          export: '匯出 CSV',
          searchPN: '搜尋料號',
          searchSN: '搜尋序號',
          searchRMA: '搜尋RMA',
          exportModal: {
            title: '匯出資料',
            all: '所有資料',
            filtered: '篩選後的資料',
            currentPage: '目前頁面',
            selected: '已選取的資料列',
            export: '匯出',
            cancel: '取消'
          }
        },
        userManagementPage: {
          pageTitle: '使用者管理',
          refresBtn: '重新整理',
          newUserModal: {
            title: '建立新使用者',
            username: '使用者名稱',
            email: '電子郵件',
            firstName: '名字',
            lastName: '姓氏',
            tempPswd: '臨時密碼',
            createUserBtn: '建立使用者',
            createdUser: '已建立的使用者:',
            vendor: '供應商',
            vendorPlaceholder: '請選擇供應商...'
          },
          vendorModal: {
            title: '管理使用者供應商',
            user: '使用者',
            userPlaceholder: '請選擇使用者',
            vendor: '供應商',
            vendorPlaceholder: '請選擇供應商',
            saveVendorBtn: '儲存供應商',
          },
          adminModal: {
            title: '管理員商家指派管理',
            admin: '管理員',
            adminPlaceholder: '請選擇管理員',
            business: '商家',
            businessPlaceholder: '請選擇商家',
            saveBusinessBtn: '儲存商家',
          },
          newAdminModal: {
            title: '建立新管理員',
            username: '使用者名稱',
            email: '電子郵件',
            firstName: '名字',
            lastName: '姓氏',
            tempPswd: '臨時密碼',
            business: '商家',
            businessPlaceholder: '請選擇商家',
            createAdminBtn: '建立管理員',
            createdAdmin: '已建立的管理員',
          },
          alertMessages: {
            failedLoadUsers: '無法載入使用者',
            failedLoadVendors: '無法載入供應商',
            failedLoadUsersVendors: '無法載入使用者的供應商',
            successCreateUser: '使用者建立成功',
            failedCreateUser: '建立使用者失敗',
            successSaveVendor: '供應商儲存成功',
            failedSaveVendor: '供應商儲存失敗',
            usernameRequired: '請輸入使用者名稱',
            emailRequired: '請輸入電子郵件',
            invalidEmail: '電子郵件格式不正確',
            firstnameRequired: '請輸入名字',
            lastnameRequired: '請輸入姓氏',
            pwdRequired: '請輸入密碼',
            chooseUserRequired: '請選擇使用者',
            successUpdateBusiness: '商家更新成功。',
            successRemoveBusiness: '商家指派已成功移除。',
            failedUpdateBusiness: '商家指派更新失敗。',
            failedLoadAdmins: '無法載入管理員。',
            failedLoadBusinesses: '無法載入商家。',
            invalidAdminEmailDomain: '電子郵件地址網域不正確',
            businessRequired: 'Business 為必填項目',
            vendorRequired: '供應商為必填項目',
          },
          tabs: {
            createUser: '建立新使用者',
            createAdmin: '建立新管理員',
            vendorManagement: '供應商管理',
            adminManagement: '管理員管理',
          }
        },
      },
    },
  },

  lng: 'hu',
  fallbackLng: 'en',

  interpolation: {
    escapeValue: false,
  },
})

export default i18n
